<template>
  <div class="filters-container">
    <el-row :gutter="24">
      <custom-input
        v-model="filters.Descripcion"
        :label="'Descripción'"
        :spanColumn="5"
        :settings="{
          placeholder: 'Buscar por descripción',
        }"
      />
      <el-col
        :span="3"
        class="button-container"
      >
        <el-button
          type="primary"
          size="default"
          @click="filtrarColores"
          >Filtrar</el-button
        >
        <el-popover
          placement="right"
          :width="40"
          effect="dark"
          trigger="hover"
          content="Limpiar filtros"
        >
          <template #reference>
            <el-button
              type="danger"
              size="default"
              :icon="IconDelete"
              @click="limpiarFiltros"
            ></el-button>
          </template>
        </el-popover>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import CustomInput from '@/shared/components/custom_input.vue';
import { useColoresStore } from '../stores/colores_store.js';
import IconDelete from '~icons/mdi/delete';

const coloresStore = useColoresStore();
const { filters } = storeToRefs(coloresStore);

const limpiarFiltros = async () => {
  coloresStore.resetFilters();
  await coloresStore.firstColores();
};

const filtrarColores = async () => {
  await coloresStore.firstColores();
};
</script>

<style scoped>
.filters-container {
  background-color: white;
  border: 3px solid lightgray;
  padding: 20px;
}
.button-container {
  margin-top: auto;
}
</style>
